import userState from './userState';
import {changePassword} from '../../../logic/api.js';
import {hashPassword, isAuthenticated} from '../../../logic/authHelpers';
import * as userDataLogic from '../../../logic/api/userData.js';
//import {getCart} from '../../Cart/redux/cartActions';
import {remove, concat, filter, reduce} from 'lodash';

export const onChangePassword = (password, newPassword) => (dispatch) => {
  dispatch({
    type: 'USER-DATA:ON-PASSWORD-CHANGE'
  });

  return changePassword(hashPassword(password), hashPassword(newPassword))
    .then((res) => {
      if (res.error) {
        dispatch(onChangePasswordError(res.error));
        throw res.error;
      }
      dispatch(onChangePasswordSuccess());
    })
    .catch((error) => {
      dispatch(onChangePasswordError(error));
      throw error;
    });
};

const onChangePasswordSuccess = () => ({
  type: 'USER-DATA:ON-CHANGE-PASSWORD-SUCCESS'
});

const onChangePasswordError = (err) => ({
  type: 'USER-DATA:ON-CHANGE-PASSWORD-ERROR',
  err
});

export const fetchPartialUserData = () => (dispatch) => {
  dispatch({
    type: 'USER-DATA:FETCH-PARTIAL-USER-DATA'
  });
  //this method replaced by getCartCount
  if (isAuthenticated()) {
    userDataLogic.getPartialSettings()
      .then((res) => {
        if (res.error)
          dispatch(fetchPartialUserDataError(res.err));
        else{
          userDataLogic.setPartialSettings(res)
          .then(()=>{
            dispatch(fetchPartialUserDataSuccess(res));
          })
          .catch((err) => dispatch(fetchPartialUserDataError(err)));}

      })
      .catch((err) => dispatch(fetchPartialUserDataError(err)));
  }
};

export const fetchPartialUserDataSuccess = (userData) => ({
  type: 'USER-DATA:FETCH-PARTIAL-USER-DATA-SUCCESS',
  userData: userData
});

const fetchPartialUserDataError = (err) => ({
  type: 'USER-DATA:FETCH-PARTIAL-USER-DATA-ERROR',
  err
});

export const fetchUserData = () => dispatch => {
  dispatch({
    type: 'USER-DATA:FETCH-USER-DATA'
  });
  if (isAuthenticated()) {
    userDataLogic.getUserData()
      .then((res) => {
        if (res.error)
          dispatch(fetchUserDataError(res.err));
        else
          dispatch(fetchUserDataSuccess(res));
      })
      .catch((err) => dispatch(fetchUserDataError(err)));
  }
};

const fetchUserDataSuccess = (userData) => ({
  type: 'USER-DATA:FETCH-USER-DATA-SUCCESS',
  userData: userData
});

const fetchUserDataError = (err) => ({
  type: 'USER-DATA:FETCH-USER-DATA-ERROR',
  err
});

export const changeUserFullName = (name) => ({
  type: 'USER-DATA:CHANGE-INPUT-FULL-NAME',
  firstName: name
});

export const changeUserEmail = (email) => ({
  type: 'USER-DATA:CHANGE-INPUT-EMAIL',
  email: email
});

export const changeUserBirthday = (birthday) => ({
  type: 'USER-DATA:CHANGE-INPUT-BIRTHDAY',
  birthday: birthday
});

export const changeUserGender = (gender) => ({
  type: 'USER-DATA:CHANGE-RADIO-GENDER',
  gender: gender
});
export const changeUserNotify = (notifyBy) => ({
  type: 'USER-DATA:CHANGE-NOTIFY',
  notifyBy
});
export const updateNotifyTime = (time) => dispatch => {
  dispatch({
    type: 'USER-DATA:UPDATE-NOTIFY-TIME',
    time
  });

  userDataLogic.updateNotifyTime(time)
    .then((res) => {
      if (res.error)
        dispatch(updateNotifyTimeError(res.err));
      else
        dispatch(updateNotifyTimeSuccess(time));
    })
    .catch((err) => dispatch(updateNotifyTimeError(err)));
};
export const updateNotifyTimeSuccess = (time) => ({
  type: 'USER-DATA:UPDATE-NOTIFY-TIME-SUCCESS',
  time
});
const updateNotifyTimeError = (err) => ({
  type: 'USER-DATA:UPDATE-NOTIFY-TIME-ERROR',
  err
});

export const updateUserData = (userData) => dispatch => {
  dispatch({
    type: 'USER-DATA:UPDATE-USER-DATA'
  });

  userDataLogic.updateUserData(userData)
    .then((res) => {
      if (res.error)
        dispatch(updateUserDataError(res.err));
      else
        dispatch(updateUserDataSuccess(userData));
    })
    .catch((err) => dispatch(updateUserDataError(err)));
};

const updateUserDataSuccess = (userData) => ({
  type: 'USER-DATA:UPDATE-USER-DATA-SUCCESS',
  userData: userData
});

const updateUserDataError = (err) => ({
  type: 'USER-DATA:UPDATE-USER-DATA-ERROR',
  err
});

export const fetchLegalTypes = () => dispatch => {
  dispatch({
    type: 'USER-DATA:FETCH-LEGALS-TYPE'
  });

  userDataLogic.getLegalTypes()
    .then((res) => {
      if (res.error)
        dispatch(fetchLegalTypesError(res.err));
      else{
        dispatch(fetchLegalTypesSuccess(res));
        userDataLogic.setLegalTypesToSessionStorage(res);
      }

    })
    .catch((err) => dispatch(fetchLegalTypesError(err)));
};

const fetchLegalTypesSuccess = (legalTypes) => ({
  type: 'USER-DATA:FETCH-LEGALS-TYPE-SUCCESS',
  LegalTypes: legalTypes
});

const fetchLegalTypesError = (err) => ({
  type: 'USER-DATA:FETCH-LEGALS-TYPE-ERROR',
  err
});

export const getUserLegals = () => dispatch => {
  dispatch({
    type: 'USER-DATA:GET-LEGALS'
  });

  userDataLogic.getUserLegals()
    .then((res) => {
      if (res.error)
        dispatch(getUserLegalsError(res.err));
      else {
        dispatch(getUserLegalsSuccess(res));
      }
    })
    .catch((err) => dispatch(getUserLegalsError(err)));
};

const getUserLegalsSuccess = (res) => ({
  type: 'USER-DATA:GET-LEGALS-SUCCESS',
  legals: res
});

const getUserLegalsError = (err) => ({
  type: 'USER-DATA:GET-LEGALS-ERROR',
  err
});

export const addOrUpdateLegals = (userLegals) => dispatch => {
  dispatch({
    type: 'USER-DATA:ADD-OR-UPDATE-LEGALS'
  });

  userDataLogic.addOrUpdateLegals(userLegals)
    .then((res) => {
      if (res.error)
        dispatch(addOrUpdateLegalsError(res.err));
      else {
        dispatch({type: 'USER-DATA:ADD-OR-UPDATE-LEGALS-SUCCESS'});
        dispatch(getUserLegals());
      }
    })
    .catch((err) => dispatch(addOrUpdateLegalsError(err)));
};

const addOrUpdateLegalsError = (err) => ({
  type: 'USER-DATA:ADD-OR-UPDATE-LEGALS-ERROR',
  err
});


/**
 * Remove user legals
 */
export const removeUserLegals = (userLegals) => dispatch => {
  dispatch({
    type: 'USER-DATA:REMOVE-LEGALS'
  });

  userDataLogic.removeUserLegals(userLegals)
    .then((res) => {
      if (res.error)
        dispatch(removeUserLegalsError(res.err));
      else {
        dispatch(removeUserLegalsSuccess());
        dispatch(getUserLegals());
      }
    })
    .catch((err) => dispatch(removeUserLegalsError(err)));
};

const removeUserLegalsSuccess = () => ({
  type: 'USER-DATA:REMOVE-LEGALS-SUCCESS'
});

const removeUserLegalsError = (err) => ({
  type: 'USER-DATA:REMOVE-LEGALS-ERROR',
  err
});
/**
 *  user default payment
 *  get delete ? because already has
 */
export const getPaymentsDefault = () => dispatch => {
  dispatch({
    type: 'USER-DATA:GET-PAYMENT-DEFAULT'
  });

  userDataLogic.getPaymentsDefault()
    .then((res) => {
      if (res.error)
        dispatch(getPaymentsDefaultError(res.err));
      else {
        dispatch(getPaymentsDefaultSuccess(res));
      }
    })
    .catch((err) => dispatch(getPaymentsDefaultError(err)));
};

const getPaymentsDefaultSuccess = (paymentDefault) => ({
  type: 'USER-DATA:GET-PAYMENT-DEFAULT-SUCCESS',
  paymentDefault: paymentDefault
});

const getPaymentsDefaultError = (err) => ({
  type: 'USER-DATA:GET-PAYMENT-DEFAULT-ERROR',
  err
});


export const setPaymentsDefault = (id, modal = false) => dispatch => {
  dispatch({
    type: 'USER-DATA:SET-PAYMENT-DEFAULT'
  });
  if (modal) { // don,t save paymentsDefault from modal
    dispatch(setPaymentsDefaultSuccess(id));
  } else {
    userDataLogic.setPaymentsDefault(id)
      .then((res) => {
        if (res.error)
          dispatch(setPaymentsDefaultError(res.err));
        else {
          dispatch(setPaymentsDefaultSuccess(id));
        }
      })
      .catch((err) => dispatch(setPaymentsDefaultError(err)));
  }

};

const setPaymentsDefaultSuccess = (paymentDefault) => ({
  type: 'USER-DATA:SET-PAYMENT-DEFAULT-SUCCESS',
  paymentDefault: paymentDefault
});

const setPaymentsDefaultError = (err) => ({
  type: 'USER-DATA:SET-PAYMENT-DEFAULT-ERROR',
  err
});
/**
 * Get user address.
 */
export const getUserAddresses = () => dispatch => {
  dispatch({
    type: 'USER-DATA:GET-ADDRESSES'
  });

  userDataLogic.getUserAddresses()
    .then((res) => {
      if (res.error)
        dispatch(getUserAddressesError(res.err));
      else {
        dispatch(getUserAddressesSuccess(res));
      }
    })
    .catch((err) => dispatch(getUserAddressesError(err)));
};

const getUserAddressesSuccess = (res) => ({
  type: 'USER-DATA:GET-ADDRESSES-SUCCESS',
  deliveryAddresses: res
});

const getUserAddressesError = (err) => ({
  type: 'USER-DATA:GET-ADDRESSES-ERROR',
  err
});

/**
 * Add or update user address.
 */
export const addOrUpdateAddresses = (userAddresses) => dispatch => {
  dispatch({
    type: 'USER-DATA:ADD-OR-UPDATE-ADDRESSES'
  });

  userDataLogic.addOrUpdateAddresses(userAddresses)
    .then((res) => {
      if (res.error)
        dispatch(addOrUpdateAddressesError(res.err));
      else {
        dispatch(addOrUpdateAddressesSuccess());
        dispatch(getUserAddresses());
      }
    })
    .catch((err) => dispatch(addOrUpdateAddressesError(err)));
};

const addOrUpdateAddressesSuccess = () => ({
  type: 'USER-DATA:ADD-OR-UPDATE-ADDRESSES-SUCCESS'
});

const addOrUpdateAddressesError = (err) => ({
  type: 'USER-DATA:ADD-OR-UPDATE-ADDRESSES-ERROR',
  err
});

/**
 * Remove user address.
 */
export const removeUserAddresses = (userAddresses) => dispatch => {
  dispatch({
    type: 'USER-DATA:ADDRESSES-LEGALS'
  });

  userDataLogic.removeUserAddresses(userAddresses)
    .then((res) => {
      if (res.error)
        dispatch(removeUserAddressesError(res.err));
      else {
        dispatch(removeUserAddressesSuccess());
        dispatch(getUserAddresses());
      }
    })
    .catch((err) => dispatch(removeUserAddressesError(err)));
};

const removeUserAddressesSuccess = () => ({
  type: 'USER-DATA:REMOVE-ADDRESSES-SUCCESS'
});

const removeUserAddressesError = (err) => ({
  type: 'USER-DATA:REMOVE-ADDRESSES-ERROR',
  err
});
/**
 * Get user emails.
 */
export const getUserEmails = () => dispatch => {
  dispatch({
    type: 'USER-DATA:GET-EMAILS'
  });

  userDataLogic.getUserEmails()
    .then((res) => {
      if (res.error)
        dispatch(getUserEmailsError(res.err));
      else {
        dispatch(getUserEmailsSuccess(res));
      }
    })
    .catch((err) => dispatch(getUserEmailsError(err)));
};

const getUserEmailsSuccess = (res) => ({
  type: 'USER-DATA:GET-EMAILS-SUCCESS',
  emails: res
});

const getUserEmailsError = (err) => ({
  type: 'USER-DATA:GET-EMAILS-ERROR',
  err
});
/**
 * Add or update user email.
 */
export const addOrUpdateEmail = (useremail) => dispatch => {
  dispatch({
    type: 'USER-DATA:ADD-OR-UPDATE-EMAIL'
  });

  userDataLogic.addOrUpdateEmail(useremail)
    .then((res) => {
      if (res.error)
        dispatch(addOrUpdateEmailError(res.err));
      else {
        dispatch(addOrUpdateEmailSuccess());
        dispatch(getUserEmails());
      }
    })
    .catch((err) => dispatch(addOrUpdateEmailError(err)));
};
const addOrUpdateEmailSuccess = () => ({
  type: 'USER-DATA:ADD-OR-UPDATE-EMAIL-SUCCESS'
});

const addOrUpdateEmailError = (err) => ({
  type: 'USER-DATA:ADD-OR-UPDATE-EMAIL-ERROR',
  err
});

/**
 * Remove user email.
 */
export const removeUserEmail = (userEmail) => dispatch => {
  dispatch({
    type: 'USER-DATA:REMOVE-EMAIL'
  });

  userDataLogic.removeUserEmail(userEmail)
    .then((res) => {
      if (res.error)
        dispatch(removeUserEmailError(res.err));
      else {
        dispatch(removeUserEmailSuccess());
        dispatch(getUserEmails());
      }
    })
    .catch((err) => dispatch(removeUserEmailError(err)));
};

const removeUserEmailSuccess = () => ({
  type: 'USER-DATA:REMOVE-EMAIL-SUCCESS'
});

const removeUserEmailError = (err) => ({
  type: 'USER-DATA:REMOVE-EMAIL-ERROR',
  err
});
/**
 * Get user garage
 */
export const getUserGarage = () => dispatch => {
  dispatch({
    type: 'USER-DATA:GET-GARAGE'
  });

  userDataLogic.getUserGarage()
    .then((res) => {
      if (res.error)
        dispatch(getUserGarageError(res.err));
      else {
        dispatch(getUserGarageSuccess(res));
      }
    })
    .catch((err) => dispatch(getUserGarageError(err)));
};

const getUserGarageSuccess = (garage) => ({
  type: 'USER-DATA:GET-GARAGE-SUCCESS',
  Garage: garage
});

const getUserGarageError = (err) => ({
  type: 'USER-DATA:GET-GARAGE-ERROR',
  err
});

/**
 * Update user garage
 */
export const updateUserGarage = (garage) => dispatch => {
  dispatch({
    type: 'USER-DATA:UPDATE-GARAGE'
  });

  userDataLogic.updateUserGarage(garage)
    .then((res) => {
      if (res.error)
        dispatch(updateUserGarageError(res.err));
      else {
        dispatch(updateUserGarageSuccess());
        dispatch(getUserGarage());
      }
    })
    .catch((err) => dispatch(updateUserGarageError(err)));
};

const updateUserGarageSuccess = () => ({
  type: 'USER-DATA:UPDATE-GARAGE-SUCCESS'
});

const updateUserGarageError = (err) => ({
  type: 'USER-DATA:UPDATE-GARAGE-ERROR',
  err
});

/**
 * Delete user garage
 */
export const deleteUserGarage = (garageId) => dispatch => {
  dispatch({
    type: 'USER-DATA:DELETE-GARAGE'
  });

  userDataLogic.deleteUserGarage([{GarageId: garageId}])
    .then((res) => {
      if (res.error)
        dispatch(deleteUserGarageError(res.err));
      else {
        dispatch(deleteUserGarageSuccess(garageId));
      }
    })
    .catch((err) => dispatch(deleteUserGarageError(err)));
};

const deleteUserGarageSuccess = (garageId) => ({
  type: 'USER-DATA:DELETE-GARAGE-SUCCESS',
  garageId
});

const deleteUserGarageError = (err) => ({
  type: 'USER-DATA:DELETE-GARAGE-ERROR',
  err
});


export const setNewPhone = (newPhone) => ({
  type: 'USER-DATA:SET-USER-NEW-PHONE',
  NewPhone: newPhone
});

export const changePhone = (phone) => ({
  type: 'USER-DATA:CHANGE-PHONE',
  phone: phone
});


/**
 * Social networks
 */
export const deleteSocialNetwork = (socialNetworkDataId) => dispatch => {
  dispatch({
    type: 'USER-DATA:DETELE-SOCIAL-NETWORK'
  });

  userDataLogic.deleteSocialNetwork([{SocialNetworkDataId: socialNetworkDataId}])
    .then((res) => {
      if (res.error)
        dispatch(deleteSocialNetworkError(res.err));
      else
        dispatch(deleteSocialNetworkSuccess(socialNetworkDataId));
    })
    .catch((err) => dispatch(deleteSocialNetworkError(err)));
};

const deleteSocialNetworkSuccess = (socialNetworkDataId) => ({
  type: 'USER-DATA:DETELE-SOCIAL-NETWORK-SUCCESS',
  socialNetworkDataId
});

const deleteSocialNetworkError = (err) => ({
  type: 'USER-DATA:DETELE-SOCIAL-NETWORK-ERROR',
  err
});

/**
 * Balance - transaction
 */
export const fetchUserTransaction = (filters) => dispatch => {
  if(filters.page==0) {
    dispatch({
      type: 'USER-DATA:FETCH-USER-TRANSACTIONS'
    });
  }
  userDataLogic.getUserTransactions(filters)
    .then((res) => {
      if(res.error)
        dispatch(fetchUserTransactionError(res.error));
      else
        dispatch(fetchUserTransactionSuccess(res));
    })
    .catch((err) => dispatch(fetchUserTransactionError(err)));
};

const fetchUserTransactionSuccess = (transactions) => ({
  type: 'USER-DATA:FETCH-USER-TRANSACTIONS-SUCCESS',
  Transactions: transactions
});

const fetchUserTransactionError =  (err) => ({
  type: 'USER-DATA:FETCH-TRANSACTIONS-FAIL',
  err
});

export default function userReducer(state = userState.userData, action) {
  switch (action.type) {
    case 'REGISTRATION:VK-REQUEST-SENT-SUCCESS':
    case 'REGISTRATION:FB-REQUEST-SENT-SUCCESS':
    case 'SIGNIN:LOGIN-FB-REQUEST-SENT-SUCCESS':
    case 'SIGNIN:LOGIN-VK-REQUEST-SENT-SUCCESS':
    case 'SIGNIN:LOGIN-REQUEST-SENT-SUCCESS':
    case 'REGISTRATION:LOGIN-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        ...action.userData
      };
    case 'USER-DATA:FETCH-USER-DATA-SUCCESS':
    case 'USER-DATA:FETCH-PARTIAL-USER-DATA-SUCCESS':
      return {
        ...state,
        ...action.userData
      };
    case 'USER-DATA:CHANGE-INPUT-FULL-NAME':
      return {
        ...state,
        firstName: action.firstName
      };
    case 'USER-DATA:CHANGE-INPUT-EMAIL':
      return {
        ...state,
        email: action.email
      };
    case 'USER-DATA:CHANGE-INPUT-BIRTHDAY':
      return {
        ...state,
        birthday: action.birthday
      };
    case 'USER-DATA:CHANGE-RADIO-GENDER':
      return {
        ...state,
        gender: action.gender
      };
    case 'USER-DATA:CHANGE-NOTIFY':
      return {
        ...state,
        ...action.notifyBy
      };
    case 'USER-DATA:UPDATE-NOTIFY-TIME':
      return {
        ...state,
        ...action.time
      };
    case 'USER-DATA:GET-LEGALS-SUCCESS':
      return {
        ...state,
        legals: action.legals
      };
    case 'USER-DATA:FETCH-LEGALS-TYPE-SUCCESS':
      return {
        ...state,
        LegalTypes: action.LegalTypes
      };
    case 'USER-DATA:GET-PAYMENT-DEFAULT-SUCCESS':
      return {
        ...state,
        paymentDefault: action.paymentDefault
      };
    case 'USER-DATA:SET-PAYMENT-DEFAULT-SUCCESS':
      return {
        ...state,
        paymentDefault: action.paymentDefault
      };
    case 'USER-DATA:GET-ADDRESSES-SUCCESS':
      return {
        ...state,
        deliveryAddresses: action.deliveryAddresses
      };
      case 'USER-DATA:GET-EMAILS-SUCCESS':
      return {
        ...state,
        emails: action.emails
      };
    case 'USER-DATA:GET-GARAGE-SUCCESS':
      return {
        ...state,
        Garage: action.Garage
      };
    case 'USER_DATA:REQUEST-CHANGE-PHONE-SUCCESS':
      return {
        ...state,
        ChangePhoneInputCurStep: action.ChangePhoneInputCurStep
      };
    case 'USER-DATA:SET-USER-NEW-PHONE':
      return {
        ...state,
        NewPhone: action.NewPhone
      };
    case 'USER-DATA:CHANGE-PHONE':
      return {
        ...state,
        phone: action.phone
      };
    case 'USER-DATA:FETCH-USER-TRANSACTIONS':
      return {
        ...state,
        Transactions: []
      };
    case 'USER-DATA:FETCH-USER-TRANSACTIONS-SUCCESS':
      return {
        ...state,
        Transactions: action.Transactions
      };
    case 'USER-DATA:FETCH-PORTION-STATES-SUCCESS':
      return {
        ...state,
        portionStates: action.portionStates
      };
    case 'USER-DATA:REQUEST-INMOTIONS':
      return {
        ...state,
        Inmotions: []
      };
    case 'USER-DATA:REQUEST-INMOTIONS-SUCCESS': {
      let Inmotions = {...action.Inmotions};
      if (Inmotions.page > 0) {
        Inmotions.orders = concat(state.Inmotions.orders, Inmotions.orders);
      }
      return {
        ...state,
        Inmotions
      };
    }

    case 'USER-DATA:REQUEST-INMOTIONS-FAIL': {
      let Inmotions = {...state.Inmotions};
      Inmotions.isNext =false;
      return {
        ...state,
        Inmotions,
        Error: action.err
      };
    }

    case 'USER-ORDERS:SET-PORTION-ARCHIVE-SUCCESS':{
      let Inmotions = {...state.Inmotions};
      Inmotions.orders = reduce(Inmotions.orders, (results, value)=>{
        let newValue = {...value},
          portions = filter(newValue.portions, (o)=> o.portionId !== action.archiveId);
        if(portions.length === 0) return results;
        newValue.portions = portions;
        return concat(results, newValue);
      }, {});
      return {
        ...state,
        Inmotions
      };
    }
    case 'USER-DATA:REQUEST-INMOTIONS-COUNT-SUCCESS':
      return {
        ...state,
        InmotionsCount: action.InmotionsCount
      };
    case 'USER-DATA:DETELE-SOCIAL-NETWORK-SUCCESS': {
      const socialNetworks = remove(state.socialNetworks, (socialNetwork) => !(+socialNetwork.SocialNetworkDataId == +action.socialNetworkDataId));
      return {
        ...state,
        socialNetworks: socialNetworks
      };
    }
    case 'USER-DATA:DELETE-GARAGE-SUCCESS': {
      const garage = remove(state.Garage, (carGarage) => !(+carGarage.GarageId == +action.garageId));
      return {
        ...state,
        Garage: garage
      };
    }
    case 'MLM:JOIN-REQUEST-SUCCESS':
      return {
        ...state,
        Roles: [...state.Roles, 'MlmMember']
      };
    case 'MLM:GET-FULL-DATA-SUCCESS':
      return {
        ...state,
        ...action.mlmData
      };
    case 'MLM:GET-DETALIZATION-DATA-SUCCESS':
      return {
        ...state,
        groupData: action.groupData
      };
    case 'USER-DATA:FETCH-TRANSACTIONS-FAIL':
    case 'USER-DATA:FETCH-PORTION-STATES-ERROR':
    case 'USER-DATA:REQUEST-INMOTIONS-COUNT-FAIL':
    case 'USER-DATA:DETELE-SOCIAL-NETWORK-ERROR':
    case 'USER-DATA:GET-PAYMENT-DEFAULT-ERROR':
    case 'USER-DATA:SET-PAYMENT-DEFAULT-ERROR':
    case 'USER-DATA:DELETE-GARAGE-ERROR':
    case 'USER-DATA:UPDATE-NOTIFY-TIME-ERROR':
    case 'MLM:JOIN-REQUEST-ERROR':
    case 'MLM:GET-FULL-DATA-FAIL':
    case 'USER-ORDERS:SET-PORTION-ARCHIVE-ERROR':
    case 'USER-DATA:FETCH-PARTIAL-USER-DATA-ERROR':
      return {
        ...state,
        Error: action.err
      };
    default:
      return state;
  }
}





/** WEBPACK FOOTER **
 ** ./src/components/User/redux/userAction.js
 **/